// Row-scoped strict-restore retry ladder. Combined auto+user failures retry
// user-only before falling back to raw, so an auto marker can never silently
// remove a user's explicit glossary choice.
const failures = (res) => [...(res?.stats?.glossaryFailed ?? [])];

function retryFuel(res, failed) {
  const fuel = [...res.rowTexts];
  for (const index of failed) fuel[index] = '';
  return fuel;
}

export async function runGlossaryRetryLadder({
  runOnce,
  initial,
  combinedGlossary,
  combinedTm,
  userGlossary = null,
  userTm = null,
  rawTm = null,
  selectUserRetryRows = null,
  canRetry = () => true,
}) {
  let res = await runOnce({
    glossary: combinedGlossary,
    resume: initial,
    tm: combinedTm,
  });
  const firstStats = res.stats;
  const firstFailed = failures(res);
  let userRetryRows = 0;
  let rawRetryRows = 0;

  if (!firstFailed.length || res.cancelled || !canRetry()) return res;
  let rawPending = [...firstFailed];

  if (userGlossary && selectUserRetryRows) {
    const selected = new Set(selectUserRetryRows(firstFailed, res) ?? []);
    const userPending = firstFailed.filter((index) => selected.has(index));
    rawPending = firstFailed.filter((index) => !selected.has(index));
    userRetryRows = userPending.length;
    if (userPending.length) {
      res = await runOnce({
        glossary: userGlossary,
        resume: retryFuel(res, userPending),
        tm: userTm,
      });
      rawPending.push(...failures(res));
    }
    if (res.cancelled || !canRetry()) {
      return {
        ...res,
        stats: {
          ...firstStats,
          glossaryFailed: firstFailed,
          autoDictUserRetryRows: userRetryRows,
          autoDictRawRetryRows: 0,
        },
      };
    }
  }

  rawPending = [...new Set(rawPending)];
  if (!rawPending.length) {
    return {
      ...res,
      stats: {
        ...firstStats,
        glossaryFailed: firstFailed,
        autoDictUserRetryRows: userRetryRows,
        autoDictRawRetryRows: 0,
      },
    };
  }
  rawRetryRows = rawPending.length;
  res = await runOnce({
    glossary: null,
    resume: retryFuel(res, rawPending),
    tm: rawTm,
  });
  return {
    ...res,
    stats: {
      ...firstStats,
      glossaryFailed: firstFailed,
      autoDictUserRetryRows: userRetryRows,
      autoDictRawRetryRows: rawRetryRows,
    },
  };
}
